import { render, staticRenderFns } from "./SessionEntriesRegistry.vue?vue&type=template&id=55db91cb"
import script from "./SessionEntriesRegistry.vue?vue&type=script&lang=js"
export * from "./SessionEntriesRegistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports